module.exports = __webpack_public_path__ + "e4e64d58d3e0d9b394984725bcfefaed.png";